/**
 * PRD-005 mid-session deny flag. Set when any server response returns 403 —
 * the API wrappers (`api/patientRegistry.ts`, `jobs/jobsClient.ts`) write
 * here on 403, and `<AuthorizedGate>` reads here to render the deny page
 * across the whole protected surface. Cleared on logout (a fresh paste with
 * Subject_Read can recover the session).
 *
 * Why a dedicated store rather than reusing `jwtStore`: a 403 means the JWT
 * is *valid* but lacks `Subject_Read`. Clearing the JWT would dump the user
 * into the paste-modal flow, which can't fix the underlying permission
 * problem (they'd just paste the same stale token). The PRD's explicit
 * 401-vs-403 separation requires the JWT to stay cached.
 */

let denied = false;
const listeners = new Set<() => void>();

function notify() {
    for (const listener of listeners) listener();
}

export const authzStore = {
    get(): boolean {
        return denied;
    },
    setDenied(): void {
        if (denied) return;
        denied = true;
        notify();
    },
    clear(): void {
        if (!denied) return;
        denied = false;
        notify();
    },
    subscribe(listener: () => void): () => void {
        listeners.add(listener);
        return () => {
            listeners.delete(listener);
        };
    },
};

export function __resetAuthzStoreForTests(): void {
    denied = false;
    listeners.clear();
}
